import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import VersionDTO from "../../models/Version/VersionDTO";
import { VersionService } from "../../services/VersionService";
import Toast from "../../helpers/Toast";
import Layout from "../../components/Layout/Layout";

export default function Version() {
	const intl = useIntl();

	const [versionData, setVersionData] = useState<VersionDTO>({ version: '', samsysApiVersion: '' });

	const versionService = new VersionService();

	const getSystemVersion = async () => {
		const response = await versionService.GetAll();
		setVersionData(response);

		if (response.samsysApiVersion == null || response.version == null) {
			Toast.Show("error", intl.formatMessage({ id: "Screens.Version.Error" }));
		}
	};

	useEffect(() => {
		getSystemVersion();
	}, []);

	return (
		<Layout>
		<div className="pageContainer">
			<div className="pageHeader">
				<span className="pageTitle">
					<FormattedMessage id="Screens.Version.Title" />
				</span>
			</div>

			<div className="pageBody">
				<Row>
					<InputComponent xl={2} lg={3} md={5} sm={12} xs={12}
						style={{ width: "100%" }}
						type={"text"}
						value={versionData.version != null ? (versionData.version.length === 0 ? intl.formatMessage({ id: "Screens.Version.Loading" }) : versionData.version) : intl.formatMessage({ id: "Screens.Version.AttributeValueError" })}
						label={intl.formatMessage({ id: "Screens.Version.Backend" })}
						readOnly={true}
					/>
					<InputComponent xl={2} lg={3} md={5} sm={12} xs={12}
						style={{ width: "100%" }}
						type={"text"}
						value={versionData.samsysApiVersion != null ? (versionData.samsysApiVersion.length == 0 ? intl.formatMessage({ id: "Screens.Version.Loading" }) : versionData.samsysApiVersion) : intl.formatMessage({ id: "Screens.Version.AttributeValueError" })}
						label={intl.formatMessage({ id: "Screens.Version.BackendErp" })}
						readOnly={true}
					/>
				</Row>
			</div>
		</div>
	</Layout>
	)
}